// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__dE7J-","main-image":"Header_main-image__3A7SF"};